import { createContext, useContext, useMemo, type ReactNode } from "react";
import type { Role } from "./roles";
import type { Capability } from "./capabilities";
import { capabilitiesForRoles, expandRoles } from "./expand";

export interface RbacContextValue {
  roles: readonly string[];
  expandedRoles: Set<Role>;
  capabilities: Set<Capability>;
}

const DEFAULT: RbacContextValue = {
  roles: [],
  expandedRoles: new Set(),
  capabilities: new Set(),
};

const RbacContext = createContext<RbacContextValue>(DEFAULT);

export interface RbacProviderProps {
  roles: readonly string[];
  children: ReactNode;
}

export function RbacProvider({ roles, children }: RbacProviderProps) {
  const value = useMemo<RbacContextValue>(
    () => ({
      roles,
      expandedRoles: expandRoles(roles),
      capabilities: capabilitiesForRoles(roles),
    }),
    [roles],
  );
  return <RbacContext.Provider value={value}>{children}</RbacContext.Provider>;
}

export function useRbac(): RbacContextValue {
  return useContext(RbacContext);
}
